import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { ManHourCsvPreviewItem } from '../types/manhour/ManHourCsvPreviewItem';

export const MANHOUR_HEADER = [
  {
    label: '社員コード',
    sortable: true,
    sortKey: 'employee_code',
    width: '200px',
  },
  { label: '氏名', sortable: false, sortKey: '', width: '200px' },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  { label: '対象期間', sortable: true, sortKey: 'month', width: '200px' },
  { label: '工数', sortable: false, sortKey: '', width: '200px' },
];

export const MANHOUR_MODAL_FIELDS: FieldDescriptor<ManHourCsvPreviewItem>[] = [
  { label: '氏名', key: 'employeeName', type: 'text' },
  { label: 'プロジェクト名', key: 'projectName', type: 'text' },
  { label: '対象期間', key: 'month', type: 'date' },
];
